import { useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      ["What we collect", "When you sign in with Google we store your name, email and profile picture to create your account. We store the projects, transcripts, caption edits and payment records you create while using Caption Motion."],
      ["How we use it", "Your data is used solely to provide the service — authentication, saving your projects, processing transcription/translation, and handling payments. We do not sell your personal data."],
      ["Media & uploads", "Uploaded videos and generated exports are stored to provide editing and export features. You control your projects and can delete them at any time."],
      ["Third parties", "We use Razorpay to process payments and Resend to send transactional email. Their handling of data is governed by their own policies. Payment card/UPI details are handled entirely by Razorpay — we never see or store them."],
      ["Contact", "For any privacy request, reach us through the Contact Us page."],
    ],
  },
  terms: {
    title: "Terms of Service",
    body: [
      ["Acceptable use", "You agree to use Caption Motion lawfully and to upload only content you have the right to use. You are responsible for your videos, audio, fonts and images."],
      ["Accounts", "You are responsible for activity under your account. Free accounts include the configured project allowance; Pro access is a one-time 28-day purchase with no automatic renewal."],
      ["Service availability", "We aim for high availability but provide the service on an \"as is\" basis without warranties of uninterrupted operation."],
      ["Intellectual property", "You retain rights to your content. Caption Motion retains rights to the application and its underlying technology."],
      ["Changes", "We may update these terms; continued use after changes constitutes acceptance."],
    ],
  },
  refund: {
    title: "Refund & Cancellation Policy",
    body: [
      ["One-time purchases", "Caption Motion Pro is a one-time payment granting exactly 28 days of Pro access. There is no automatic renewal and no recurring charge."],
      ["Cancellation", "Because access is a fixed 28-day period with no auto-renewal, there is nothing to cancel — access simply expires at the end of the period unless you purchase again."],
      ["Refunds", "If you experience a genuine problem (for example a failed activation after a successful charge), contact us through the Contact Us page and we will review your case and process an appropriate refund in line with applicable law and Razorpay's rules."],
      ["How refunds are issued", "Approved refunds are returned to the original payment method via Razorpay. We do not store your payment details."],
    ],
  },
};

export default function Legal() {
  const type = useLocation().pathname.replace("/", "") || "privacy";
  const data = CONTENT[type] || CONTENT.privacy;
  return (
    <div className="flex min-h-screen flex-col bg-[#0A0A0A] text-white" data-testid={`legal-${type}`}>
      <Navbar />
      <div className="mx-auto w-full max-w-3xl flex-1 px-5 py-14">
        <h1 className="mb-2 font-display text-4xl font-black tracking-tight sm:text-5xl">{data.title}</h1>
        <p className="mb-10 text-sm text-[#666]">Last updated {new Date().toLocaleDateString(undefined, { year: "numeric", month: "long" })}</p>
        <div className="space-y-8">
          {data.body.map(([h, p]) => (
            <section key={h}>
              <h2 className="mb-2 font-display text-lg font-bold text-white">{h}</h2>
              <p className="text-sm leading-relaxed text-[#A1A1AA]">{p}</p>
            </section>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
